import { Classroom } from '@/api/classroom'

const state = () => ({
    classrooms: [],
    classroomsPagination: {},
    classroom: null,
    createdClassroom: null,
    isLoadingClassrooms: false,
    isSuccessClassrooms: true,
    messageClassrooms: '',
    allClassrooms: [],
    allClassroomsActive: [],
    classroomMember: [],
    classroomMemberPagination: {},
    savedIdClassroom: 0,
    filterClassrooms: [],
    isLoadingFilterClassrooms: false,
    classroomFree: [],
    classroomFreePagination: {},
    classroomFreeDetail: null,
    userClassrooms: [],
    isLoadingUserClassrooms: false,
    classroomUserDetail: {
        perPage: 10,
        first: 0,
    },
    loadingUserQuestion: false,
    userQuestions: [],
    saveClassroomUserQuestion: 0,
    userQuestionsPagination: {},
})

const getters = {
    classroomsList: state => state.classrooms,
    classroomsPagination: state => state.classroomsPagination,
    classroom: state => state.classroom,
    createdClassroom: state => state.createdClassroom,
    isLoadingClassrooms: state => state.isLoadingClassrooms,
    isSuccessClassrooms: state => state.isSuccessClassrooms,
    messageClassrooms: state => state.messageClassrooms,
    allClassrooms: state => state.allClassrooms,
    allClassroomsActive: state => state.allClassroomsActive,
    classroomMember: state => state.classroomMember,
    savedIdClassroom: state => state.savedIdClassroom,
    classroomMemberPagination: state => state.classroomMemberPagination,
    filterClassrooms: state => state.filterClassrooms,
    isLoadingFilterClassrooms: state => state.isLoadingFilterClassrooms,
    classroomFreeList: state => state.classroomFree,
    classroomFreePagination: state => state.classroomFreePagination,
    classroomFreeDetail: state => state.classroomFreeDetail,
    userClassrooms: state => state.userClassrooms,
    isLoadingUserClassrooms: state => state.isLoadingUserClassrooms,
    classroomUserDetail: state => state.classroomUserDetail,
    loadingUserQuestion: state => state.loadingUserQuestion,
    userQuestions: state => state.userQuestions,
    saveClassroomUserQuestion: state => state.saveClassroomUserQuestion,
    userQuestionsPagination: state => state.userQuestionsPagination,
}

const actions = {
    async fetchAllClassrooms({ commit }, query = null) {
        let page = 1
        let perPage = 10
        let search = ''
            // let current = 0
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
                // current = query.current
        }

        commit('setClassroomIsLoading', true)
            // commit('setCurrentPageClassroom', current)
        await Classroom.list(perPage, page, search)
            .then(res => {
                commit('setClassrooms', res.data.data)
                const pagination = {
                    total: res.data.pages.total,
                    per_page: res.data.pages.per_page,
                    page: res.data.pages.current_page,
                    from: res.data.pages.from,
                }
                commit('setClassroomsPagination', pagination)
                commit('setClassroomIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setClassroomIsLoading', false)
            })
    },
    async fetchDetailClassroom({ commit }, id) {
        commit('setClassroomIsLoading', true)
        await Classroom.detail(id)
            .then(response => {
                // console.log(response)
                commit('setClassroomDetail', response.data.data)
                commit('setClassroomIsLoading', false)
                commit('setSuccessClassroom', true)
            })
            .catch(error => {
                console.log(error)
                commit('setClassroomIsLoading', false)
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
            })
    },
    async updateClassroom({ commit }, classroom) {
        const id = classroom.id
        const payload = classroom.payload

        await Classroom.editClassroom(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Mengubah Kelas')
                } else {
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
            })
    },
    async addClassroom({ commit }, payload) {
        commit('setClassroomIsLoading', true)
        await Classroom.addClassroom(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setClassroomIsLoading', false)
                    commit('setCreatedClassroom', res.data.data)
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Menambahkan Kelas')
                } else {
                    commit('setClassroomIsLoading', false)
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
            })
    },
    async deleteClassroom({ commit }, id) {
        await Classroom.classroomDelete(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Menghapus Kelas')
                } else {
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', true)
                commit('setMessageClassroom', error.errors[0].message)
            })
    },
    async fetchListClassrooms({ commit }) {
        commit('setLoadingFilterClassrooms', true)
        await Classroom.classroomAllSimple()
        .then(res => {
            commit('setSuccessClassroom', true)
            commit('setListClassrooms', res.data.data)
            commit('setLoadingFilterClassrooms', false)
        })
        .catch(error => {
            commit('setLoadingFilterClassrooms', false)
            commit('setSuccessClassroom', false)
            commit('setMessageClassroom', error)
        })
    },
    async fetchListClassroomsActive({commit}) {
        commit('setLoadingFilterClassrooms', true)
        await Classroom.classroomAllSimpleActive()
        .then(res => {
            commit('setLoadingFilterClassrooms', false)
            commit('setListClassroomsActive', res.data.data)
        })
        .catch(err => {
            commit('setLoadingFilterClassrooms', false)
            commit('setMessageClassrooms', err)
        })
    },
    async fetchClassroomMember({ commit }, query) {

        let id = query.id
        let page = query.page
        let perPage = query.perPage
        let search = ''
        let isGraduated = ''
        let graduatedDate = []
        let joinedDate = []
        let orderBy = ''
        let sortBy = ''

        commit('setSavedIdClassroom', id)
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
            isGraduated = query.isGraduated
            graduatedDate = query.graduatedDate
            joinedDate = query.joinedDate
            orderBy = query.orderBy
            sortBy = query.sortBy
        }

        commit('setClassroomIsLoading', true)
        await Classroom.classroomMember(id, perPage, page, search, isGraduated, graduatedDate, joinedDate, orderBy, sortBy)
            .then(res => {
                commit('setClassroomMember', res.data.data)
                const pagination = {
                    total: res.data.pages.total,
                    per_page: res.data.pages.per_page,
                    current_page: res.data.pages.current_page,
                    isGraduated,
                    graduatedDate,
                    joinedDate,
                    orderBy,
                    sortBy,
                }
                commit('setClassroomMemberPagination', pagination)
                commit('setClassroomIsLoading', false)
                commit('setSuccessClassroom', true)
            })
            .catch(error => {
                console.log(error)
                commit('setClassroomIsLoading', false)
                commit('setSuccessClassroom', false)
            })
    },
    async fetchFilterClassrooms({ commit }, search) {
        commit('setLoadingFilterClassrooms', true)
        await Classroom.classroomSearch(search)
            .then(res => {
                commit('setFilterClassrooms', res.data.data)
                commit('setLoadingFilterClassrooms', false)
            })
            .catch(error => {
                commit('setLoadingFilterClassrooms', false)
                commit('setMessageClassroom', error.errors[0].message)
            })
    },
    async fetchClassroomsFreeList({ commit }) {
        commit('setClassroomIsLoading', true)

        await Classroom.classroomFreeList()
            .then(res => {
                commit('setClassroomFreeList', res.data.data)
                    // const pagination = {
                    //     total: res.data.pages.total,
                    //     per_page: res.data.pages.per_page,
                    //     current_page: res.data.pages.current_page
                    // }
                    // commit('setClassroomFreePagination', pagination)
                commit('setClassroomIsLoading', false)
                commit('setSuccessClassroom', true)
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
                commit('setClassroomIsLoading', false)
            })
    },
    async fetchClassroomFreeDetail({ commit }, id) {
        commit('setClassroomIsLoading', true)
        await Classroom.classroomFreeDetail(id)
            .then(async res => {
                const payload = {
                    classroom: res.data.data.classroom,
                    startedAt: res.data.data.started_at,
                    expiredAt: res.data.data.expired_at,
                }
                commit('setClassroomIsLoading', false)
                commit('setClassroomFreeDetail', payload)
                commit('setSuccessClassroom', true)
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error)
                commit('setClassroomIsLoading', false)
            })
    },
    async addClassroomFree({ commit, dispatch }, payload) {
        await Classroom.classroomFreeAdd(payload)
            .then(async res => {
                if (res.data.success) {
                    await dispatch('fetchClassroomsFreeList')
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Menambahkan Kelas Gratis')
                    commit('setClassroomIsLoading', false)
                } else {
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                    commit('setClassroomIsLoading', false)
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
                commit('setClassroomIsLoading', false)
            })
    },
    async updateClassroomFree({ commit, dispatch }, data) {
        const id = data.id
        const payload = data.payload
        await Classroom.classroomFreeUpdate(id, payload)
            .then(async res => {
                if (res.data.success) {
                    await dispatch('fetchClassroomsFreeList')
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Mengupdate Kelas Gratis')
                    commit('setClassroomIsLoading', false)
                } else {
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                    commit('setClassroomIsLoading', false)
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
                commit('setClassroomIsLoading', false)
            })
    },
    async deleteClassroomFree({ commit }, id) {
        await Classroom.classroomFreeDelete(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessClassroom', true)
                    commit('setMessageClassroom', 'Berhasil Menghapus Kelas Gratis')
                    commit('setClassroomIsLoading', false)
                } else {
                    commit('setSuccessClassroom', false)
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                    commit('setClassroomIsLoading', false)
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error.errors[0].message)
                commit('setClassroomIsLoading', false)
            })
    },
    async historyUserClassroom({ commit }, uuid) {
        commit('setIsLoadingUserClassrooms', true)
        await Classroom.getUserClassroom(uuid)
            .then(res => {
                commit('setIsLoadingUserClassrooms', false)
                commit('setUserClassrooms', res.data.data)
            })
            .catch(error => {
                console.log(error)
                commit('setIsLoadingUserClassrooms', false)
            })
    },
    async userAddToClass({ commit }, payload) {
        await Classroom.assignUserClassroom(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setMessageClassroom', 'Berhasil Menambahkan Kelas')
                    commit('setSuccessClassroom', true)
                } else {
                    commit('setMessageClassroom', 'Terjadi Kesalahan')
                    commit('setSuccessClassroom', false)
                }
            })
            .catch(error => {
                commit('setSuccessClassroom', false)
                commit('setMessageClassroom', error)
            })
    },
    saveClassroomUserDetail({commit}, pages) {
        commit("setClassroomUserDetail", pages)
    },
    updateClassroomMemberList({commit}, data) {
        commit('setClassroomMember', data)
    },
    async fetchUserQuestions({commit}, query = null) {
        commit('setLoadinUserQuestion', true)
        commit('setSaveClassroomUserQuestion', query.id)
        let page = 1
        let perPage = 10
        if (query) {
            page = query.page
            perPage = query.perPage
        }
        await Classroom.getUserQuestion(query.id, page, perPage)
        .then(res => {
            commit('setLoadinUserQuestion', false)
            commit('setUserQuestion', res.data.data)
            commit('setUserQuestionPagination', res.data.pages)
        })
        .catch(err => {
            commit('setLoadinUserQuestion', false)
            console.log(err)
        })
    },
}

const mutations = {
    setClassroomUserDetail: (state, pages) => {
        state.classroomUserDetail = pages
    },
    setClassrooms: (state, classrooms) => {
        state.classrooms = classrooms
    },
    setClassroomsPagination: (state, classroomsPagination) => {
        state.classroomsPagination = classroomsPagination
    },
    setClassroomDetail: (state, classroom) => {
        state.classroom = classroom
    },

    setCreatedClassroom: (state, createdClassroom) => {
        state.createdClassroom = createdClassroom
    },

    setClassroomIsLoading: (state, isLoadingClassrooms) => {
        state.isLoadingClassrooms = isLoadingClassrooms
    },

    setSuccessClassroom: (state, isSuccessClassrooms) => {
        state.isSuccessClassrooms = isSuccessClassrooms
    },

    setMessageClassroom: (state, messageClassrooms) => {
        state.messageClassrooms = messageClassrooms
    },

    setListClassrooms: (state, classrooms) => {
        state.allClassrooms = classrooms
    },

    setListClassroomsActive: (state, classrooms) => {
        state.allClassroomsActive = classrooms    
    },

    setClassroomMember: (state, classroomMember) => {
        state.classroomMember = classroomMember
    },
    setSavedIdClassroom: (state, savedIdClassroom) => {
        state.savedIdClassroom = savedIdClassroom
    },
    setClassroomMemberPagination: (state, classroomMemberPagination) => {
        state.classroomMemberPagination = classroomMemberPagination
    },

    setFilterClassrooms: (state, filter) => {
        state.filterClassrooms = filter
    },

    setLoadingFilterClassrooms: (state, status) => {
        state.isLoadingFilterClassrooms = status
    },

    setClassroomFreeList: (state, classroomFree) => {
        state.classroomFree = classroomFree
    },

    setClassroomFreePagination: (state, pagination) => {
        state.classroomFreePagination = pagination
    },

    setClassroomFreeDetail: (state, detail) => {
        state.classroomFreeDetail = detail
    },

    setUserClassrooms: (state, history) => {
        state.userClassrooms = history
    },

    setIsLoadingUserClassrooms: (state, loading) => {
        state.isLoadingUserClassrooms = loading
    },

    setSaveClassroomUserQuestion: (state, code) => {
        state.saveClassroomUserQuestion = code
    },

    setUserQuestion: (state, questions) => {
        state.userQuestions = questions
    },

    setUserQuestionPagination: (state, pagination) => {
        state.userQuestionsPagination = pagination
    },
    setLoadinUserQuestion(state, loading) {
        state.loadingUserQuestion = loading
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}